import React from "react";
import "./downloadApp.css";

export default function DownloadApp() {
  return (
    <div className="download-container">
      <h2>🚀 ¡Descarga nuestra App Interna!</h2>
      <p className="subtitle">
        Disponible exclusivamente para colaboradores de la empresa.
      </p>

      {/* PRIMERO: Instrucciones */}
      <div className="download-instructions">
        <p><strong>Instrucciones para Android:</strong></p>
        <ol>
          <li>
            Abre este enlace <strong>directamente</strong> en tu dispositivo Android.
          </li>
          <li>
            Al terminar la descarga, abre la notificación o ve a la carpeta <code>Descargas</code>.
          </li>
          <li>
            Si es la primera vez que instalas una APK, ve a <em>Ajustes → Seguridad</em> y habilita <em>Orígenes desconocidos</em>.
          </li>
          <li>
            Toca el archivo <code>quality-route.apk</code> para instalar.
          </li>
          <li>
            Una vez instalada, abre la app desde tu menú de aplicaciones.
          </li>
          <li>
            La aplicación necesita permisos de <strong>cámara</strong>, <strong>ubicación</strong> y <strong>notificaciones</strong>. Asegúrate de configurarlos en <em>“Permitir siempre”</em> en tu sistema.
          </li>
          <li className="highlight">
            Si aún no tienes usuario y contraseña, contacta al área de Sistemas para crearlos.
          </li>
        </ol>
      </div>

      {/* DESPUÉS: Botón de descarga */}
      <a
        href="/assets/apk/quality-route.apk"
        className="download-btn"
        download="quality-route.apk"
      >
        📥 Descargar APK
      </a>
    </div>
  );
}
